/**
 * Поиск «не в той раскладке» (владелец CRM 06.10.2026: набрал «njvc» вместо
 * «томс» — «Ничего не нашли»). Копия frontend/src/lib/keyboard-layout.ts:
 * импорт между пакетами запрещён. Стандартные раскладки ЙЦУКЕН ↔ QWERTY на
 * одних клавишах; строка переводится в обе стороны.
 */
const EN = "`qwertyuiop[]asdfghjkl;'zxcvbnm,./~QWERTYUIOP{}ASDFGHJKL:\"ZXCVBNM<>?";
const RU = 'ёйцукенгшщзхъфывапролджэячсмитьбю.ЁЙЦУКЕНГШЩЗХЪФЫВАПРОЛДЖЭЯЧСМИТЬБЮ,';

const EN_TO_RU = new Map<string, string>();
const RU_TO_EN = new Map<string, string>();
for (let i = 0; i < EN.length; i++) {
  EN_TO_RU.set(EN[i], RU[i]);
  if (!RU_TO_EN.has(RU[i])) RU_TO_EN.set(RU[i], EN[i]);
}

const convert = (s: string, map: Map<string, string>): string => [...s].map((c) => map.get(c) ?? c).join('');

/** Строка как есть + та же строка, набранная в другой раскладке (в нижнем регистре). */
export function layoutVariants(query: string): string[] {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  const out = new Set([q, convert(q, EN_TO_RU).toLowerCase(), convert(q, RU_TO_EN).toLowerCase()]);
  return [...out];
}

/** Содержит ли текст запрос — в любой из двух раскладок. Пустой запрос — да. */
export function matchesAnyLayout(haystack: string, query: string): boolean {
  const vs = layoutVariants(query);
  if (vs.length === 0) return true;
  const h = haystack.toLowerCase();
  return vs.some((v) => h.includes(v));
}
